document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.getElementById('product-grid');
  const loadMoreContainer = document.getElementById('LoadMoreContainer');

  if (!productGrid || !loadMoreContainer) return;

  loadMoreContainer.addEventListener('click', function (e) {
    const btn = e.target.closest('#LoadMoreButton');
    if (!btn) return;

    e.preventDefault();

    const url = btn.getAttribute('href');
    btn.textContent = 'Betöltés...';
    btn.style.opacity = '0.6';
    btn.style.pointerEvents = 'none';

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Új termékek hozzáfűzése
        const newItems = doc.querySelectorAll('#product-grid .grid__item');
        newItems.forEach((item) => productGrid.appendChild(item));

        // Következő oldal gomb frissítése
        const newLoadMore = doc.getElementById('LoadMoreContainer');
        if (newLoadMore) {
          loadMoreContainer.innerHTML = newLoadMore.innerHTML;
        } else {
          loadMoreContainer.innerHTML = '';
        }

        // URL frissítése (opcionális, back gomb miatt hasznos)
        window.history.pushState({}, '', url);
      })
      .catch(() => {
        btn.textContent = 'Hiba történt – próbáld újra';
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
      });
  });
});
